module.exports = __webpack_public_path__ + "static/img/arrow-up.cdfa8d39.svg";